export default "__VITE_ASSET__8d6abd16__"